'use client'

import { MapboxMapSkeleton } from '@component/mapbox/map'
import AboutAreaContext from './context'
import { useState } from 'react'
import dynamic from 'next/dynamic'
import { useBoolean } from 'react-use'
import { useRecoilValue } from 'recoil'
import { Waypoint } from 'react-waypoint'
import { global } from '@store/index'
const MapboxMap = dynamic(() => import('@component/mapbox/map'), { ssr: false, loading: () => <MapboxMapSkeleton /> })
const MapboxPolyline = dynamic(() => import('@component/mapbox/layer/polyline'), { ssr: false })
const MapboxCenterMarker = dynamic(() => import('@component/mapbox/marker/center'), { ssr: false })
const MapboxSchoolMarkerList = dynamic(() => import('@component/mapbox/marker/school/list'), { ssr: false })

export default function AboutArea({
  lng,
  lat,
  zoom = 18,
  centerMarker = true,
  fullscreenControl = true,
  children,
  className = '',
  mapBeforeChildren,
  height = 516,
  onResize
}) {

  const { isMobile } = useRecoilValue(global)
  // commute要渲染的路线
  const [routeGeojson, setRouteGeojson] = useState()
  // 是否显示中心点marker
  const [displayCenterMarker, toggleCenterMarker] = useBoolean(centerMarker)
  // 当前要显示的学校
  const [schoolList, setSchoolList] = useState()
  // 当前选中的学校
  const [currentSchool, setCurrentSchool] = useState()
  // mapbox公用数据
  const [commonData, setCommonData] = useState({})

  // 是否显示地图
  const [showMap, toggleMap] = useBoolean(false)

  return (
    <Waypoint onEnter={() => toggleMap(true)}>
      <div className={className}>
        <AboutAreaContext.Provider value={{
          lng,
          lat,
          zoom,
          setRouteGeojson,
          toggleCenterMarker,
          setSchoolList,
          currentSchool,
          setCurrentSchool,
          commonData,
          setCommonData
        }}>
          {
            showMap
              ? (
                <div className='flex flex-col' style={{ height }}>
                  <MapboxMap
                    id='about-area'
                    lng={lng}
                    lat={lat}
                    zoom={zoom}
                    scrollZoom={false}
                    dragPan={!isMobile}
                    satelliteControl
                    mapBeforeChildren={mapBeforeChildren}
                    fullscreenControl={fullscreenControl}
                    onResize={onResize}
                  >
                    {children}
                    {displayCenterMarker && <MapboxCenterMarker lng={lng} lat={lat}></MapboxCenterMarker>}
                    {routeGeojson && <MapboxPolyline data={routeGeojson} autofitbounds={isMobile ? true : { padding: { top: 30, bottom: 30, left: 430, right: 30 } }}></MapboxPolyline>}
                    {schoolList && <MapboxSchoolMarkerList data={schoolList}></MapboxSchoolMarkerList>}
                  </MapboxMap>
                </div>
              )
              : (
                <MapboxMapSkeleton height={height}></MapboxMapSkeleton>
              )
          }
        </AboutAreaContext.Provider>
      </div>
    </Waypoint>
  )
}